// extracted by mini-css-extract-plugin
export default {"select":"WsB6Z","selectDisabled":"AiPSp","item":"a0jP7","itemActive":"pK14S","text":"BkRin","icon":"S7ih_"};